import React, { useContext } from 'react';
import { UiContext } from 'shared/lib/contexts/uiContext';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function StaticTableCellItemLink({ text }: { text: string }) {
  const { t } = useTranslation();
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <Typography
      component={'a'}
      href={text}
      color="primary.main"
      sx={{
        p: sp.s30,
        display: 'flex',
        width: 1,
        cursor: 'pointer',
        textDecoration: 'none',
      }}
      target="_blank"
      variant="f16"
    >
      {t('formFields.link')}
    </Typography>
  );
}
